import { EmitterConfigV3 } from '@pixi/particle-emitter';
import { Texture } from 'pixi.js';

const ParticleGhost: EmitterConfigV3 = {
  lifetime: {
    max: 0.2,
    min: 0.01,
  },
  particlesPerWave: 1,
  frequency: 0.001,
  spawnChance: 1,
  emitterLifetime: -1,
  maxParticles: 1000,
  pos: {
    x: 0,
    y: -16,
  },
  emit: false,
  behaviors: [
    {
      type: 'alpha',
      config: {
        alpha: {
          list: [
            {
              value: 0,
              time: 0,
            },
            {
              value: 1,
              time: 0.1,
            },
            {
              value: 0.1,
              time: 1,
            },
          ],
        },
      },
    },
    {
      type: 'scale',
      config: {
        scale: {
          list: [
            {
              value: 1,
              time: 0,
            },
            {
              value: 0.5,
              time: 1,
            },
          ],
        },
      },
    },
    {
      type: 'moveSpeed',
      config: {
        speed: {
          list: [
            {
              value: 15000,
              time: 0,
            },
            {
              value: 0,
              time: 1,
            },
          ],
          isStepped: false,
        },
      },
    },
    {
      type: 'rotationStatic',
      config: {
        min: 0,
        max: 360,
      },
    },
    {
      type: 'spawnShape',
      config: {
        type: 'torus',
        data: {
          x: 0,
          y: 0,
          radius: 10,
        },
      },
    },
    {
      type: 'textureSingle',
      config: {
        texture: Texture.from('/textures/objects/projectile/projectile_3.png'),
      },
    },
  ],
};

export default ParticleGhost;
